export default {
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Excluir',
    edit: 'Editar',
    view: 'Visualizar',
    back: 'Voltar',
    close: 'Fechar',
    add: 'Adicionar',
    send: 'Enviar',
    sending: 'Enviando...',
    saving: 'Salvando...',
    loading: 'Carregando...',
    search: 'Pesquisar',
    update: 'Atualizar',
    create: 'Criar',
    creating: 'Criando...',
    transfer: 'Transferir',
    approve: 'Aprovar',
    reject: 'Reprovar',
    ok: 'Entendi',
    name: 'Nome',
    username: 'Usuário',
    password: 'Senha',
    email: 'E-mail',
    date: 'Data',
    status: 'Status',
    type: 'Tipo',
    quantity: 'Quantidade',
    description: 'Descrição',
    project: 'Projeto',
    task: 'Tarefa',
    logout: 'Sair',
    notifications: 'Notificações',
    settings: 'Configurações',
    draft: 'Rascunho',
    sent: 'Enviado',
    active: 'Ativo',
    inactive: 'Inativo',
    priority: 'Prioridade',
    language: 'Idioma',
    yes: 'Sim',
    no: 'Não',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Atenção',
    required: 'Obrigatório',
    optional: 'Opcional',
    all: 'Todos',
    none: 'Nenhum',
    upload: 'Enviar arquivo',
    download: 'Baixar',
    print: 'Imprimir',
    actions: 'Ações',
    details: 'Detalhes',
    filters: 'Filtros',
    results: 'Resultados',
    noResults: 'Nenhum resultado encontrado',
    total: 'Total',
    of: 'de',
    verified: 'verificado',
    pending: 'Pendente',
    completed: 'Concluído',
    cancelled: 'Cancelado',
  },

  auth: {
    login: 'Entrar',
    loginTitle: 'Entrar na sua conta',
    logout: 'Sair',
    register: 'Cadastrar',
    forgotPassword: 'Esqueceu a senha?',
    resetPassword: 'Redefinir senha',
    usernameOrEmail: 'Usuário ou e-mail',
    enterPassword: 'Digite sua senha',
    enterUsername: 'Digite seu usuário',
    loginError: 'Usuário ou senha incorretos.',
    sessionExpired: 'Sessão expirada. Faça login novamente.',
  },

  nav: {
    dashboard: 'Painel de Controle',
    overview: 'Visão Geral',
    documents: 'Documentos',
    viewDocuments: 'Visualizar Documentos',
    manageProjects: 'Gerenciar Projetos',
    viewProjects: 'Visualizar Projetos',
    manageUsers: 'Gerenciar Usuários',
    viewUsers: 'Visualizar Usuários',
    manageWarehouse: 'Gerenciar Almoxarife',
    viewWarehouse: 'Visualizar Almoxarife',
    manageMachinery: 'Gerenciar Maquinário',
    viewMachinery: 'Visualizar Maquinário',
    manageSystem: 'Gerenciar Sistema',
    projects: 'Projetos',
    myProjects: 'Meus Projetos',
    myTasks: 'Minhas Tarefas',
    reports: 'Relatórios',
    drawings: 'Arquivos',
    warehouse: 'Almoxarife',
    checkStock: 'Consultar Estoque',
    requests: 'Solicitações',
    requestItem: 'Solicitar Item',
    tickets: 'Chamados',
    messages: 'Mensagens',
    adminMode: 'Modo Administrador',
    standardMode: 'Modo Padrão',
    analystMode: 'Modo Analista',
    createReport: 'Criar Relatório',
    createReports: 'Relatórios de obra',
    dailyReport: 'Relatório diário de obra',
    incidentReport: 'Relatório de incidente',
    safetySection: 'Segurança do trabalho',
    safetyDialog: 'Diálogos de segurança',
    workPermit: 'Permissão de trabalho crítico',
    occurrenceReport: 'Relatório de ocorrido',
    settingsMenu: 'Configurações',
  },

  profile: {
    editProfile: 'Editar perfil',
    displayName: 'Nome',
    usernameLabel: 'Nome de usuário',
    passwordLabel: 'Senha',
    changePassword: 'Trocar senha',
    appearance: 'Aparência',
    lightMode: 'Modo claro',
    darkMode: 'Modo escuro',
    languageLabel: 'Idioma',
    cropTitle: 'Recortar foto de perfil',
    cropUse: 'Usar esta área',
    zoom: 'Zoom',
    currentPassword: 'Confirmar senha anterior',
    newPassword: 'Senha nova',
    confirmNewPassword: 'Confirmar senha nova',
    emailVerified: 'verificado',
    emailChange: 'Alterar',
    emailSendCode: 'Enviar código',
    emailConfirm: 'Confirmar',
    emailResend: '← Reenviar código',
    emailCancelChange: 'Cancelar',
    emailSending: 'Enviando...',
    emailVerifying: 'Verificando...',
    emailHint: 'Código enviado para {email}. Verifique sua caixa e spam.',
    emailSuccess: 'E-mail {email} verificado com sucesso.',
    emailInvalidError: 'Informe um e-mail válido.',
    emailGenericError: 'Erro ao enviar código.',
    emailInvalidCode: 'Código inválido.',
    passwordFillAll: 'Preencha todos os campos de troca de senha.',
    passwordWrong: 'A senha anterior está incorreta.',
    passwordMismatch: 'A confirmação da nova senha não confere.',
    saveFillAll: 'Preencha nome e usuário.',
    saveFinishPassword: 'Finalize ou cancele a troca de senha antes de salvar.',
    avatarAlt: 'perfil',
  },

  dashboard: {
    overview: 'Visão geral',
    myProjects: 'Meus projetos',
    myTasks: 'Minhas tarefas',
    activeProjects: 'Projetos ativos',
    completedTasks: 'Tarefas concluídas',
    pendingTasks: 'Tarefas pendentes',
    recentActivity: 'Atividade recente',
    noProjects: 'Nenhum projeto encontrado.',
    noTasks: 'Nenhuma tarefa encontrada.',
    createProject: 'Criar projeto',
    projectName: 'Nome do projeto',
    startDate: 'Data de início',
    endDate: 'Data de término',
  },

  projects: {
    title: 'Projetos',
    newProject: 'Novo projeto',
    projectName: 'Nome do projeto',
    startDate: 'Início',
    endDate: 'Término',
    progress: 'Progresso',
    team: 'Equipe',
    gantt: 'Planejamento',
    files: 'Arquivos',
    tickets: 'Chamados',
    warehouse: 'Almoxarife',
    dds: 'DDS',
    reports: 'Relatórios',
    noProjects: 'Nenhum projeto.',
    deleteConfirm: 'Tem certeza que deseja excluir este projeto?',
  },

  tasks: {
    title: 'Tarefas',
    newTask: 'Nova tarefa',
    taskName: 'Nome da tarefa',
    assignee: 'Responsável',
    dependencies: 'Dependências',
    duration: 'Duração (dias)',
    startDate: 'Início',
    endDate: 'Término',
    progress: 'Progresso',
    addProgress: 'Registrar progresso',
    noTasks: 'Nenhuma tarefa.',
    blocked: 'Bloqueada',
    inProgress: 'Em andamento',
    done: 'Concluída',
    deleteConfirm: 'Excluir esta tarefa?',
  },

  warehouse: {
    title: 'Almoxarifado',
    stock: 'Estoque',
    requestItem: 'Solicitar item',
    requests: 'Solicitações',
    addItem: 'Adicionar item',
    itemName: 'Nome do item',
    category: 'Categoria',
    unit: 'Unidade',
    available: 'Disponível',
    reserved: 'Reservado',
    transferItem: 'Transferir item',
    reportDamage: 'Relatar dano',
    provideEquipment: 'Fornecer equipamento',
    noItems: 'Nenhum item no estoque.',
    noRequests: 'Nenhuma solicitação.',
    approveRequest: 'Aprovar solicitação',
    rejectRequest: 'Reprovar solicitação',
    requestStatus: {
      pending: 'Pendente',
      approved: 'Aprovado',
      rejected: 'Reprovado',
      delivered: 'Entregue',
    },
  },

  safety: {
    title: 'Segurança',
    dds: 'DDS',
    ddsTitle: 'Diálogo Diário de Segurança',
    newDds: 'Novo DDS',
    occurrences: 'Ocorrências',
    permits: 'Permissões',
    createDialog: 'Criar diálogo',
    createOccurrence: 'Registrar ocorrência',
    createPermit: 'Criar permissão',
    topic: 'Tema',
    presenter: 'Apresentador',
    attendees: 'Participantes',
    date: 'Data',
    noSafety: 'Nenhum registro de segurança.',
  },

  tickets: {
    title: 'Chamados',
    newTicket: 'Novo chamado',
    subject: 'Assunto',
    category: 'Categoria',
    openedBy: 'Aberto por',
    assignedTo: 'Atribuído a',
    openTickets: 'Chamados abertos',
    closedTickets: 'Chamados fechados',
    noTickets: 'Nenhum chamado.',
    status: {
      open: 'Aberto',
      inProgress: 'Em andamento',
      closed: 'Fechado',
    },
  },

  users: {
    title: 'Usuários',
    newUser: 'Novo usuário',
    role: 'Cargo',
    roles: {
      adminMaster: 'Admin Master',
      adminObra: 'Admin Obra',
      user: 'Usuário',
    },
    noUsers: 'Nenhum usuário.',
    deleteConfirm: 'Excluir este usuário?',
    manageRoles: 'Gerenciar cargos',
    manageUsers: 'Gestão de usuários',
    userList: 'Lista de usuários',
  },

  system: {
    title: 'Configurações do sistema',
    siteName: 'Nome do sistema',
    logo: 'Logo',
    loginBackground: 'Fundo do login',
    primaryColor: 'Cor primária',
    save: 'Salvar configurações',
    saved: 'Configurações salvas.',
  },

  reports: {
    title: 'Relatórios',
    daily: 'Relatório diário',
    incident: 'Relatório de incidente',
    noReports: 'Nenhum relatório.',
    createReport: 'Criar relatório',
    date: 'Data',
    author: 'Autor',
    content: 'Conteúdo',
  },

  machinery: {
    title: 'Maquinário Pesado',
    newMachine: 'Novo equipamento',
    machineName: 'Nome',
    model: 'Modelo',
    plate: 'Placa',
    status: 'Status',
    noMachinery: 'Nenhum equipamento.',
  },

  messenger: {
    title: 'Mensagens',
    newMessage: 'Nova mensagem',
    noMessages: 'Nenhuma mensagem.',
    typeMessage: 'Digite uma mensagem...',
    send: 'Enviar',
  },
}
